import { useEffect, useState } from 'react';
import Sparcal from '../../lib/Sparcal';
import Form from 'react-bootstrap/Form';
import { Button, Popover } from 'antd';
import './ForestDataMapBoundaryColor.css';
import { HexColorPicker } from 'react-colorful';

const ForestDataMapBoundaryColor = (props) => {
  const { gisData, setFilterItems, savedColor } = props;
  const [color, setColor] = useState(savedColor ?? '#000000');
  const [confirmedColor, setConfirmedColor] = useState(savedColor ?? '#000000');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await Sparcal.getSLDForBoundary(
        gisData.service_url,
        gisData.layer_name
      ).then((response) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, 'application/xml');

        const strokeColor =
          xmlDoc.getElementsByTagName('sld:CssParameter')[0].textContent;

        setColor(strokeColor);
        setConfirmedColor(strokeColor);
      });
    };
    // A color picked earlier wins over the layer's default style.
    if (gisData && !savedColor) {
      fetchData();
    }
  }, []);

  const colorChange = (newColor) => {
    setColor(newColor);
    setConfirmedColor(newColor);
    setFilterItems(newColor);
  };

  return (
    <Form>
      <Popover
        trigger="click"
        title="Select color"
        open={open}
        content={
          <div style={{ backgroundColor: '#CEDBD6' }}>
            <HexColorPicker color={color} onChange={setColor} />
            <div
              style={{
                marginTop: '4px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Button
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                className="btn_primary"
                onClick={() => {
                  colorChange(color);
                  setOpen(false);
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        }
      >
        <Button
          onClick={() => {
            setOpen(!open);
          }}
          style={{
            backgroundColor: confirmedColor,
            borderWidth: '5px',
            borderColor: '#e4e3d3',
            height: '28px',
            width: '64px',
            marginTop: '2px',
          }}
          aria-label="Boundary color select"
        />
      </Popover>
    </Form>
  );
};
export default ForestDataMapBoundaryColor;
